import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { selectDealerSelected } from 'app/pages/Header/selectors';
import { hasDealerContext } from 'utils/hasDealerContext';

export type StaticContentValueMessagesBreadcrumb = {
  label: string;
  link?: string;
  isActive?: boolean;
};

export const useStaticContentValueMessagesPage = () => {
  const location = useLocation();
  const selectedDealer = useSelector(selectDealerSelected);

  const breadcrumbsList = useMemo(
    (): StaticContentValueMessagesBreadcrumb[] => {
      const fromState = (
        location.state as
          | { breadcrumbsList?: StaticContentValueMessagesBreadcrumb[] }
          | null
      )?.breadcrumbsList;
      if (fromState?.length) {
        return fromState;
      }
      return [{ label: 'Static Content - Value Messages', isActive: true }];
    },
    [location.state],
  );

  return {
    breadcrumbsList,
    hasDealer: hasDealerContext(selectedDealer),
  };
};
